import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { BUILD_PHASES } from "../../model/BUILD_PHASES";
import type { CatalogBuildPurchase } from "../../model/HeroBuilds";
import { BuildItems } from "../BuildItems";

const TITLE = msg({ id: "builds.details.purchases", message: "Purchases" });
const CAPTION = msg({
  id: "builds.details.purchases_caption",
  message:
    "Under the icon, the minute of purchase and how many players with this build take the item",
});

type BuildPurchasesProps = {
  purchases: readonly CatalogBuildPurchase[];
};

// Закуп раскрытой сборки по фазам матча: что берут сильные с этой сборкой (от четверти
// купивших), к какой минуте и какая доля их берёт.
export const BuildPurchases = ({ purchases }: BuildPurchasesProps) => {
  const { _ } = useLingui();
  const phases = BUILD_PHASES.map((phase, index) => {
    const fromS = BUILD_PHASES[index - 1]?.untilS ?? 0;
    const items = purchases.filter(
      (item) => item.avg_buy_time_s >= fromS && item.avg_buy_time_s < phase.untilS,
    );
    return { label: _(phase.label), items };
  }).filter((phase) => phase.items.length > 0);
  return (
    <section className="flex flex-col gap-2.5" aria-label={_(TITLE)}>
      <h4 className="text-[15px] font-semibold">{_(TITLE)}</h4>
      {phases.map((phase) => (
        <div key={phase.label} className="flex flex-col gap-1.5">
          <span className="text-xs text-subtle">{phase.label}</span>
          <BuildItems
            size={48}
            items={phase.items.map((item) => ({
              itemId: item.item_id,
              atS: item.avg_buy_time_s,
              pickRate: item.pick_rate,
            }))}
          />
        </div>
      ))}
      <span className="text-xs text-subtle">{_(CAPTION)}</span>
    </section>
  );
};
